import { EndpointCategory } from './types'
import { clientEndpoints } from './clientEndpoints'
import { adminEndpoints } from './adminEndpoints'

export const categories: EndpointCategory[] = [
    {
        id: 'introduction',
        title: {
            pt: 'Introdução',
            en: 'Introduction'
        },
        description: {
            pt: 'Bem-vindo à documentação da API EmpreX. Esta API fornece serviços financeiros para usuários finais, incluindo gerenciamento de empréstimos, processamento de pagamentos e integrações.',
            en: 'Welcome to the EmpreX API documentation. This API provides financial services for end users, including loan management, payment processing, and integrations.'
        },
        endpoints: []
    },
    {
        id: 'authentication',
        title: {
            pt: 'Autenticação',
            en: 'Authentication'
        },
        description: {
            pt: 'A API EmpreX utiliza dois métodos de autenticação dependendo do tipo de operação.',
            en: 'The EmpreX API uses two authentication methods depending on the operation type.'
        },
        endpoints: []
    },
    {
        id: 'admin-api',
        title: {
            pt: 'API Administrativa',
            en: 'Admin API'
        },
        description: {
            pt: 'Endpoints para operações administrativas do parceiro. A Admin API serve principalmente para: (1) Gerar tokens JWT para integração com a Client API ou Webview, permitindo que seus usuários acessem os serviços de crédito; (2) Processar cobranças de empréstimos através de dois modelos de negócio: Retenção percentual do fluxo de caixa (um percentual fixo dos valores repassados ao usuário é retido automaticamente para pagamento do empréstimo) ou Parcelamento incorporado ao billing (parcelas adicionadas à cobrança recorrente da plataforma). Requerem autenticação via Bearer token ou x-api-key.',
            en: 'Endpoints for partner administrative operations. The Admin API primarily serves to: (1) Generate JWT tokens for integration with the Client API or Webview, allowing your users to access credit services; (2) Process loan payments through two business models: Cash flow percentage retention (a fixed percentage of amounts transferred to the end user is automatically retained for loan payment) or Billing-integrated installments (installments added to the platform\'s recurring billing). Require authentication via Bearer token or x-api-key.'
        },
        endpoints: adminEndpoints
    },
    {
        id: 'client-api',
        title: {
            pt: 'API de Cliente',
            en: 'Client API'
        },
        description: {
            pt: 'Endpoints para operações de cliente (usuários finais). Necessária apenas se você estiver construindo seu próprio front-end. Se usar o Webview da EmpreX, você só precisa implementar a Admin API. Todos os endpoints (exceto /webview-config) requerem autenticação via token JWT.',
            en: 'Endpoints for client operations (end users). Only required if you are building your own front-end. If using EmpreX Webview, you only need to implement the Admin API. All endpoints (except /webview-config) require JWT token authentication.'
        },
        endpoints: clientEndpoints
    }
]

export * from './types'
export { clientEndpoints, adminEndpoints }
